import components from './components'
import graphql from './graphql'
import pages from './pages'
import store from './store'

export default {
    components,
    graphql,
    pages,
    store,
    errorCodes: {
        unknownCode: 'Unbekannter Fehlercode'
    }
}
